module.exports = __webpack_public_path__ + "static/gostin1-740f5937e17abf06fa90219e2374fb64.webp";